module.exports = __webpack_public_path__ + "static/people-c18713e749d2e7c640684f3565b10e1e.jpg";